module.exports = __webpack_public_path__ + "static/media/rule1.fdfc0eef.png";